var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "line-haul-status-code"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.isRedirect) ? _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend'), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("⚠️ Page Not Available")]), _vm._v(" "), _c('p', [_vm._v("LH Status code marking has been moved to Incident Management System. Please mark LH Status code from the following Link:\n                      "), _c('a', {
    attrs: {
      "href": _vm.imsLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.imsLink))])])])])])])])], 1)]) : _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Update LineHaul Status Code")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ShippingId')
    },
    attrs: {
      "type": "text",
      "rows": "15",
      "max-rows": "15",
      "placeholder": "Enter ShippingID, Use Comma For Multiple ShippingID's And Maximum shipment Limit is 500",
      "name": "ShippingId",
      "id": "ShippingId"
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShippingId')),
      expression: "errors.has('ShippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShippingId')))]), _vm._v(" "), (_vm.shipmentLimt) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shipmentLimtMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('BagNo')
    },
    attrs: {
      "type": "text",
      "rows": "15",
      "max-rows": "15",
      "placeholder": "Enter Bag No, Use Comma For Multiple Bag's And Maximum Bag Limit is 500",
      "name": "BagNo",
      "id": "BagNo"
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BagNo')),
      expression: "errors.has('BagNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('BagNo')))]), _vm._v(" "), (_vm.bagLimt) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagLimtMsg))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("LH Receive Status Code")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('StatusCode')
    },
    attrs: {
      "options": _vm.statuscodelist,
      "selected-option": _vm.statuscodeitem,
      "name": "StatusCode",
      "placeholder": "Select Status Code"
    },
    on: {
      "select": _vm.selectStatusCode
    },
    model: {
      value: (_vm.statuscode),
      callback: function($$v) {
        _vm.statuscode = $$v
      },
      expression: "statuscode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('StatusCode')),
      expression: "errors.has('StatusCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('StatusCode')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("LH Track After Hours")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-map-signs'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trackafterhours),
      expression: "trackafterhours"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('TrackAfterHours')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Track After Hours",
      "name": "TrackAfterHours",
      "id": "TrackAfterHours"
    },
    domProps: {
      "value": (_vm.trackafterhours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trackafterhours = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('TrackAfterHours')),
      expression: "errors.has('TrackAfterHours')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('TrackAfterHours')))]), _vm._v(" "), (_vm.trackAfterHoursLimit) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.trackAfterHoursLimitMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:300'),
      expression: "'max:300'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Comments')
    },
    attrs: {
      "type": "text",
      "maxlength": "300",
      "placeholder": "Enter Comments",
      "name": "Comments",
      "id": "Comments",
      "onkeypress": "return (event.charCode >= 46 && event.charCode <= 57) || (/[a-zA-Z]/i.test(event.key)) || event.charCode == 32"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Comments')),
      expression: "errors.has('Comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Comments')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "flex-end"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update")]), _vm._v("  \n                      "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])], 1)], 1)])])], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bd43b74","hasScoped":true}!./src/views/components/LineHaulStatusCode/LineHaulStatusCode.html
// module id = 1165
// module chunks = 2